import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { useAuthenticated } from "../../authn";
import { AsyncResult } from "../../shared";
import { OrgContext } from "./OrgContext";

interface OrgProviderProps {
  children: React.ReactNode;
}

export function OrgProvider({ children }: OrgProviderProps) {
  const auth = useAuthenticated();

  const ownOrgRoles = useQuery({
    queryFn: async () => {
      return await api.listOrgRolesByUser(auth.userId);
    },
    queryKey: ["listOrgRolesByUser", auth.userId],
    refetchInterval: false,
  });

  const ownOrgs = useQuery({
    queryFn: async () => {
      return await api.listOrgsByUser({ user_id: auth.userId });
    },
    queryKey: ["listOrgsByUser", auth.userId],
    refetchInterval: false,
  });

  const ownRoleInOrg = (orgId: string) => {
    return ownOrgRoles.data?.find(
      (role) => role.org_id === orgId && role.user_id === auth.userId
    );
  };

  return (
    <AsyncResult query={ownOrgRoles}>
      {(orgRoles) => (
        <AsyncResult query={ownOrgs}>
          {(orgs) => (
            <OrgContext.Provider value={{ orgRoles, orgs, ownRoleInOrg }}>
              {children}
            </OrgContext.Provider>
          )}
        </AsyncResult>
      )}
    </AsyncResult>
  );
}
